import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User cleared filters on the creative performance page',
  name: 'creative_performance_filter_cleared',
};

export default META;
